/* eslint-disable import/no-anonymous-default-export */
import { combineReducers } from 'redux-immutable';
import { connectRouter } from 'connected-react-router';
import appReducer from './app-reducer';
import dataBlog from './blog-reducer';
import upsellPopupReducer from './upsell-popup-reducer';
import upsellBundleReducer from './upsell-bundle-reducer';
import saveBarReducer from './save-bar-reducer';
import designReducer from './design-redecer';

export default history =>
  combineReducers({
    router: connectRouter(history),
    appReducer,
    dataBlog,
    saveBarReducer,
    upsellPopupReducer,
    upsellBundleReducer,
    designReducer
  });
